import { useSiteContentState } from './useSiteContent'
import fallbackOffers from '../api/fallback/offers.json'

// Même patron que le catalogue et les informations pratiques : la copie
// embarquée à la compilation s'affiche d'abord, l'API la remplace dès qu'elle
// répond.
//
// La copie de secours porte les périodes, pas des blocs déjà filtrés : c'est la
// page qui applique `isLive` au rendu. Une copie filtrée à la source afficherait
// indéfiniment la promotion de l'été où elle a été produite — l'inverse de ce que
// le repli doit faire.
export function useOffers() {
  const { data, status } = useSiteContentState('offers', fallbackOffers)
  return { offers: data, status }
}
